export const DATE_FORMAT = "DD/MM/YYYY";
// eslint-disable-next-line no-useless-escape
export const REGEX = /[\w\d\.-]+@[\w\d\.-]+\.[\w\d\.-]+/;
